// Canais de aquisição comerciais.
// Espelha contacts/choices.py do backend — manter sincronizado.
export const ACQUISITION_CHANNEL_OPTIONS = [
  { value: "whatsapp", label: "WhatsApp" },
  { value: "instagram_organic", label: "Instagram (orgânico)" },
  { value: "facebook_organic", label: "Facebook (orgânico)" },
  { value: "meta_ads", label: "Meta Ads (Facebook/Instagram)" },
  { value: "google_organic", label: "Google (orgânico)" },
  { value: "google_ads", label: "Google Ads" },
  { value: "tiktok_organic", label: "TikTok (orgânico)" },
  { value: "tiktok_ads", label: "TikTok Ads" },
  { value: "youtube", label: "YouTube" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "email_marketing", label: "Email Marketing" },
  { value: "referral", label: "Indicação" },
  { value: "prospecting", label: "Prospecção Ativa" },
  { value: "event", label: "Evento" },
  { value: "partnership", label: "Parceria" },
  { value: "walk_in", label: "Entrada Direta" },
  { value: "website", label: "Site/Website" },
  { value: "phone", label: "Telefone" },
  { value: "other", label: "Outro" },
];

export const ACQUISITION_CHANNEL_LABELS = ACQUISITION_CHANNEL_OPTIONS.reduce(
  (acc, opt) => {
    acc[opt.value] = opt.label;
    return acc;
  },
  {},
);
